import 'configurable-date-input-polyfill';
import Products from './corporativo/Products.svelte';
import ProductDetails from './corporativo/ProductDetails.svelte'

export default {
    Products: Products,
    ProductDetails: ProductDetails,
};
